<template>
  <div>

    <div class="h-content">
      <!--查询-->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="经销商编码">
              <el-input v-model="q.agentCode" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="经销商名称">
              <el-input v-model="q.agentName" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="渠道">
              <brselectlazy category="sales_region"
                            v-model="q.channelCode"  :v="q.channelCode" :clearable="true"/>
            </el-form-item>
            <el-form-item label="召开人">
              <el-input v-model="q.conveneName" :clearable="true"></el-input>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item  label="运营会时间">
                  <el-date-picker type="date" placeholder="选择日期" v-model="q.weekTime"
                                  value-format="yyyy-MM-dd" style="width: 100%;">
                  </el-date-picker>
                </el-form-item>

                  <el-form-item label="运营会开始日期" class="h-elformWrap-2" prop="startTime">
                      <el-date-picker
                          type="date"
                          placeholder="选择开始时间"
                          v-model="q.weekMonthStart"
                          value-format="yyyy-MM-dd"
                      />
                  </el-form-item>
                  <el-form-item label="运营会结束日期" class="h-elformWrap-2" prop="endTime">
                      <el-date-picker
                          type="date"
                          placeholder="选择结束时间"
                          v-model="q.weekMonthEnd"
                          value-format="yyyy-MM-dd"
                      />
                  </el-form-item>

                  <el-form-item label="省份">
                      <brselect category="YlSalesArea_chanpin" :v="q.provinceCode"  v-model="q.provinceCode" :clearable="true"></brselect>
                  </el-form-item>

              </div>
            </div>
          </el-collapse-transition>
        </el-form>


        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
            </el-button>
            <el-button
                class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                @click="createdMeeting">新增网络运营会
            </el-button>
          </div>
        </div>
      </div>
      <!--查询end-->

      <!--数据展示-->
        <!--数据展示-->
        <div class="h-table h-mrt30">
            <el-table
                ref="ddtable"
                :data="tableData"
                stripe
                border   style="width: 100%"
                :expand-row-keys="expandedRows"
                @expand-change="handleExpandChange"
                row-key="id"
                :row-class-name="tableRowClassName">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="expand-content">
                            <div v-if="loadingDetail && !rowDetailData[props.row.id]" class="expand-loading">
                                加载中...
                            </div>
                            <div v-else>
                                <div class="expand-section">
                                    <h4>直销业务详情</h4>
                                    <el-table
                                        v-if="rowDetailData[props.row.id] && rowDetailData[props.row.id].directSaleList.length > 0"
                                        :data="rowDetailData[props.row.id].directSaleList"
                                        border
                                        size="mini"
                                        style="width: 100%;">
                                        <el-table-column prop="userName" label="用户名称" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.userName }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="userType" label="用户分类" width="120">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.userType }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="amount" label="金额" width="100">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.amount }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="projectName" label="项目名称" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.projectName }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="progress" label="进度与关键任务互认" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.progress }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="lastResult" label="上次纪要闭环结果" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.lastResult }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="updateDescription" label="描述进展" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.updateDescription }}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <p v-else-if="rowDetailData[props.row.id]">暂无直销业务数据</p>
                                </div>

                                <div class="expand-section">
                                    <h4>分销业务计划</h4>
                                    <el-table
                                        v-if="rowDetailData[props.row.id] && rowDetailData[props.row.id].distributionPlanList.length > 0"
                                        :data="rowDetailData[props.row.id].distributionPlanList"
                                        border
                                        size="mini"   style="width: 100%;">
                                        <el-table-column prop="category" label="分类" width="120">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.category }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="actionDirection" label="行动方向" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.actionDirection }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="monthPlan" label="月计划" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.monthPlan }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="expectedTime" label="预计完成时间" width="120">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.expectedTime }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="weekProgress" label="周进展" width="100">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.weekProgress }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="lastResult" label="上次纪要闭环结果" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.lastResult }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="updateDescription" label="描述进展" width="150">
                                            <template slot-scope="scope">
                                                <span :class="{'old-data': scope.row.oldFlag === 1}">{{ scope.row.updateDescription }}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <p v-else-if="rowDetailData[props.row.id]">暂无分销业务计划数据</p>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    type="index"
                    width="60"
                    label="序号"
                    fixed >
                </el-table-column>
                <el-table-column
                    prop="agentCode"
                    label="经销商编码"
                    width="100"
                    fixed>
                </el-table-column>
                <el-table-column
                    prop="agentName"
                    label="经销商名称"
                    width="200"
                    :show-overflow-tooltip="true"
                    fixed>
                </el-table-column>
                <el-table-column
                    prop="channelCode"
                    label="签约渠道"
                    :show-overflow-tooltip="true"
                    width="110">
                    <template slot-scope="scope">
                        {{scope.row.channelCode | dictname('fl_sales_region_qudao')}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="provinceCode"
                    label="所在省区"
                    :show-overflow-tooltip="true"
                    width="80">
                    <template slot-scope="scope">
                        {{scope.row.provinceCode | dictname('YlSalesArea_chanpin')}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="conveneCode"
                    label="召开人编码"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="conveneName"
                    label="召开人名称"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="participants"
                    label="参会人员"
                    :show-overflow-tooltip="true"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="weekTime"
                    label="运营会时间"
                    :show-overflow-tooltip="true"
                    width="110">
                </el-table-column>


                <el-table-column
                    prop="yearTargetAmount"
                    label="年度进货目标"
                    :show-overflow-tooltip="true"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="yearTargetSaleAmount"
                    label="年度出货目标"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="endYearStockAmount"
                    label="年底期望库存金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="yearActualAmount"
                    label="年度累计进货实际"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="yearActualSaleAmount"
                    label="年度累计出货实际"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="directSaleAmount"
                    label="年度直销"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="distributionSaleAmount"
                    label="年度分销"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>


                <el-table-column
                    prop="beginStockAmount"
                    label="期初库存金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="endStockAmount"
                    label="期末库存金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="purchaseCompleteRate"
                    label="进货完成率"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="conclusion1"
                    label="进货结论"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="saleCompleteRate"
                    label="销售完成率"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="conclusion2"
                    label="销售结论"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="stockDigestionTarget"
                    label="库存消化目标"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="yearTargetPurchaseAmount"
                    label="年度累计进货目标"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="yearLjTargetSaleAmount"
                    label="年度累计出货目标"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="stockTurnoverDays"
                    label="库存周转天数"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="conclusion3"
                    label="库存结论"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>


                <el-table-column
                    prop="monthTargetAmount"
                    label="月度进货目标"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="monthTargetInstallAmount"
                    label="本月预测安装金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="monthDirectSaleAmount"
                    label="月度直销"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="monthDistributionSaleAmount"
                    label="月度分销"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="monthTargetPurchaseAmount"
                    label="月度进货预测"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="monthActualStockDigestionAmount"
                    label="实际盘点金额"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="monthPurchaseCompleteRate"
                    label="月度进货完成率"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="monthSaleCompleteRate"
                    label="月度销售出货率"
                    :show-overflow-tooltip="true"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="targetUserNum"
                    label="签约目标用户数"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="leijiUserNum"
                    label="累计覆盖用户"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="yearUserNum"
                    label="当年覆盖用户"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="leijiCoverage"
                    label="累计覆盖率"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="yearCoverage"
                    label="当年覆盖率"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="noCoveredNoloudUserNum"
                    label="未覆盖且无漏斗用户个数"
                    width="140">
                </el-table-column>
                <el-table-column
                    prop="weekPlan"
                    label="本周行动计划"
                    width="140"
                >
                    <template #default="{row}">
                        <el-tooltip
                            placement="top"
                            :popper-class="'custom-tooltip'">
                            <div slot="content" style="white-space: pre-line;">{{ row.weekPlan }}</div>
                            <span>{{row.weekPlan}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
<!--                <el-table-column
                    prop="handInput"
                    label="手工录入"
                    :show-overflow-tooltip="true"
                    width="120"
                >
                </el-table-column>-->

                <el-table-column
                    prop="cdate"
                    label="创建日期"
                    :show-overflow-tooltip="true"
                    width="140">
                </el-table-column>
                <el-table-column
                    prop="cuname"
                    label="创建人"
                    width="80">
                </el-table-column>
                <el-table-column
                    prop="grade"
                    label="评分"
                    width="70">
                </el-table-column>
                <el-table-column
                    prop="comment"
                    label="评价意见"
                    :show-overflow-tooltip="true"
                    width="140">
                </el-table-column>


                <el-table-column
                    fixed="right"
                    label="操作"
                    width="220" >
                    <template slot-scope="scope">
                        <div style="white-space: normal;">
                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="toSee(scope.row)">
                                查看
                            </el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="toChange(scope.row)"
                                class="h-tableLink h-btn"
                                v-if="isTimeEqual(scope.row)"
                            >
                                修改
                            </el-button>
                             <el-button
                                  type="text"
                                  size="small"
                                  class="h-tableLink h-btn"
                                  @click="printDetail(scope.row.id)">
                                导出明细
                              </el-button>

                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="openEvaluateDialog(scope.row)">
                                评价
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="exportExcel">批量导出</el-button>
                </div>
                <div class="h-pagination2">
                    <pagination :page="q" @query="query" />
                </div>
            </div>
        </div>

      <!--数据展示end-->
    </div>

      <!-- 评价弹窗 -->
      <el-dialog
          title="运营会评价"
          :visible.sync="evaluateDialogVisible"
          width="500px"
          :close-on-click-modal="false"
      >
          <el-form :model="evaluateForm" label-width="80px">
              <el-form-item label="评级">
                  <el-radio-group v-model="evaluateForm.grade" size="medium">
                      <el-radio-button label="A">A</el-radio-button>
                      <el-radio-button label="B">B</el-radio-button>
                      <el-radio-button label="C">C</el-radio-button>
                      <el-radio-button label="D">D</el-radio-button>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="评价意见">
                  <el-input
                      type="textarea"
                      v-model="evaluateForm.comment"
                      :rows="4"
                      placeholder="请输入评价意见"
                  />
              </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="evaluateDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitEvaluate" :loading="evaluateLoading">确认提交</el-button>
        </span>
      </el-dialog>

  </div>
</template>
<script>
import moment from "moment";
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";
import updownfile from "@/utils/updownfile";
export default {
  data(){
    return{
      // 展开折叠筛选
      isScreen:false,
      closeScreen:require("@/assets/images/pimg/closeallic.png"),
      drawScreen:require("@/assets/images/pimg/dobleArr.png"),
      q:{
        agentCode: null, //经销商编码
        agentName: null, //经销商名称
        channelCode: null, //渠道
        conveneName: null,//召开人

        weekMonthStart : null,//创建日期
        weekMonthEnd : null,//创建日期
        weekMonth: null,
        provinceCode: null,//省
        pageNo:1,
        pageSize: 10,
        total: 0,

      },
      monthList:["01","02","03","04","05","06","07","08","09","10","11","12"],
      tableData: [],
      currentTime: '',
      expandedRows: [] ,// 记录展开的行
      rowDetailData: {}, // 缓存展开行的详情数据 { id: { directSaleList, distributionPlanList } }
      loadingDetail: false ,// 加载详情loading

      // 评价弹窗
      evaluateDialogVisible: false,
      evaluateLoading: false,
      evaluateForm: {
          id: null,
          grade: '',
          comment: ''
      }
    }
  },
  methods:{


    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    query(){
        console.log(this.q,'查询条件')
        weeklyMeetingApi.selectPage2026(this.q).then(res=>{
        console.log(res)
        this.q.total = res.total
        this.tableData = res.records
        // 切换页面时清除已缓存的详情数据
        this.rowDetailData = {}
      })
    },
    //检索
    handleFilter() {
      this.q.pageNo = 1;
      this.query();
    },
    resetData(){
      this.q = {
        pageNo:1,
        pageSize: 10,
        total: 0
      }
      this.query()
    },
      tableRowClassName({row}) {
          if (row.oldFlag === 1) {
              return 'old-row';
          }
          return '';
      },

      // 处理展开行变化
      handleExpandChange(row, expandedRows) {
        console.log("this.expandedRows",expandedRows)
          this.expandedRows = expandedRows.map(item => item.id);
          // 如果展开且未加载过详情，则调用接口
          if (expandedRows.some(item => item.id === row.id) && !this.rowDetailData[row.id]) {
              this.loadingDetail = true;
              weeklyMeetingApi.selectDetailById(row.id).then(res => {
                  this.$set(this.rowDetailData, row.id, {
                      directSaleList: res.obj.directSaleList || [],
                      distributionPlanList: res.obj.distributionPlanList || []
                  });
              }).finally(() => {
                  this.loadingDetail = false;
              });
          }
      },
    //新增网络运营会
    createdMeeting() {
      this.$router.push({path: "/agent/addWeeklyMeeting2026"});
    },
    //查看详情
    toSee(row){
      this.$router.push({path: "/agent/seeWeeklyMeeting2026",query:{id:row.id}});
    },
    //修改--当天申请的可以修改
    toChange(row){
      console.log(row)
      this.$router.push({path: "/agent/addWeeklyMeeting2026",query:{id:row.id}});
    },
    //判断当前时间是否是创建那天
    isTimeEqual(row){
      return moment(new Date(row.cdate)).format('YYYY-MM-DD') == this.currentTime
    },
    printDetail(x){
      updownfile.down('/api/swyl/v1/demo/bscNetworkMeeting2026/downloadExcelDetail',{id:x},"get");
    },
    //批量导出
    exportExcel(){
      let params = {
        agentCode:this.q.agentCode,
        agentName:this.q.agentName,
        channelCode:this.q.channelCode,
        conveneName:this.q.conveneName,
        weekMonthStart : this.q.weekMonthStart,
        weekMonthEnd : this.q.weekMonthEnd,

        provinceCode:this.q.provinceCode,
      }
      weeklyMeetingApi.downloadExcelList2026(params).then(res=>{
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', `运营会列表.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },

      // 打开评价弹窗
      openEvaluateDialog(row) {
          this.evaluateForm = { id: row.id, grade: row.grade, comment: row.comment };
          this.evaluateDialogVisible = true;
      },
      // 提交评价
      submitEvaluate() {
          if (!this.evaluateForm.grade) {
              this.$message.warning('请选择评级');
              return;
          }
          if (!this.evaluateForm.comment) {
              this.$message.warning('请填写评价');
              return;
          }

          this.evaluateLoading = true;
          weeklyMeetingApi.evaluate2026(this.evaluateForm).then(res => {
              this.$message.success('评价成功');
              this.evaluateDialogVisible = false;
              this.query();
          }).catch(() => {
              this.$message.error('评价失败，请重试');
          }).finally(() => {
              this.evaluateLoading = false;
          });
      }
  },
  created() {
    this.currentTime = moment(new Date()).format('YYYY-MM-DD')
    this.query()
  },
  activated() {
    this.query()
  }
}
</script>
<style scoped>
.expand-content {
    padding: 10px;
    background-color: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.expand-loading {
    text-align: center;
    padding: 20px;
    color: #909399;
    font-size: 14px;
}

.expand-section {

}

.expand-section h4 {

}

/* oldFlag=1 行样式 */
.old-row {
    background-color: #f5f7fa !important;
}

.old-data {
    background-color: #e8e8e8 !important;
}
</style>
